import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@dc/react-components";
import { Svg } from "../../../ws10";
import { trackView } from "@dc/utag-tracking";

function TabContent(data) {

  return (
    <div className="tabs__content">
      <div
        className="background__image banner-tabs__background--image lazyloaded"
        style={{ backgroundImage: `url(${data.tabcontent.imageUrl})` }}></div>
      <section className="section section--white">
        <div className="spring banner-tabs__description">
          <h3 className="heading heading--3">{data.tabcontent.title}</h3>
          <p className="heading heading--5">{data.tabcontent.text}</p>
          <Link to="?i_code=consumer-home-rewards_banner-veryme_rewards/" className="banner-tabs__link" onClick={()=>trackView()}>
            <span className="banner-tabs__chevron--text ">
              Discover more
              <Icon Source={Svg.ChevronRight} className="icon--extra-small chevron__icon" />
            </span>
          </Link>
        </div>
      </section>
    </div>
  );
}

function Tab(data) {
  return (
    <a href={data.href} className={data.className}>
      {data.text}
    </a>
  );
}

function Tabs(data) {
  return (
    <div className="tabs__navigation-wrapper">
      <nav className="tabs__navigation tabs__navigation--fixed">
        {data.tabs.map(function (tab, index) {
          return <Tab key={index} href={tab.href} className={tab.className} text={tab.text} />;
        })}
      </nav>
      <TabContent tabcontent={data.tabcontent} />
    </div>
  );
}

export default Tabs;
